import ExamImage from "../components/ExamImage";
import { useEffect, useRef, useState } from "react"; // ⏳ ADDED useState
import { OpenSheetMusicDisplay } from "opensheetmusicdisplay";
import QuestionLayout from "./QuestionLayout";

function insertAccidental(text, acc) {
  return (text || "") + acc;
}

export default function ScoreAnnotationWidget({
  id,
  config,
  value = {},
  onChange,
  mode,
  hideFB = false,
  feedback
}) {
  const scoreImage = config.scoreImage;
  const containerRef = useRef(null);
  const osmdRef = useRef(null);
  const annotationLayerRef = useRef(null);
  const initializedRef = useRef(false);

  const modeRef = useRef(mode);
  const localMeasuresRef = useRef([]);
  const hitRegionsRef = useRef({ measures: [], symbols: [] });

  const interactionMode = config.interactionMode; // "measure" | "symbol" | "rect"
  const selectionMode = config.selections ?? "single";
  const maxSelections = Number(config.maxSelections) || null;

  const dragStartRef = useRef(null);
  const isDraggingRef = useRef(false);
  const noteheadsRef = useRef([]);
  const valueRef = useRef(value);

  const [activeTextField, setActiveTextField] = useState(null);

  // ⏳ ADDED: readiness gate
  const [ready, setReady] = useState(false);
  const readyRef = useRef(true);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  useEffect(() => {
    modeRef.current = mode;
  }, [mode]);

  /* ───────── OSMD INIT ───────── */

  useEffect(() => {
    if (scoreImage) return;
    if (initializedRef.current) return;
    initializedRef.current = true;

    const osmd = new OpenSheetMusicDisplay(containerRef.current, {
      drawTitle: false,
      drawSubtitle: false,
      drawComposer: false,
      drawLyricist: false,
      drawPartNames: false,
      drawMeasureNumbers: config.drawMeasureNumbers ? true : false,
      drawMeasureNumbersOnlyAtSystemStart: false,
      measureNumberInterval: 1,
      autoResize: false
    });

    osmdRef.current = osmd;

    (async () => {
      await osmd.load(config.musicXML);
      osmd.render();

      await new Promise(r =>
        requestAnimationFrame(() => requestAnimationFrame(r))
      );

      ensureAnnotationLayer();
      extractMeasuresFromDOM();
      extractNoteheadsFromOSMD();

      if (interactionMode === "symbol") {
        extractSymbolsFromDOM();
        drawSymbolHitRects();
      }

      if (interactionMode === "measure") {
        drawMeasureHitRects();
      }

      if (interactionMode === "rect") {
        const svg = containerRef.current.querySelector("svg");

        svg.style.touchAction = "none";
        svg.style.userSelect = "none";
        svg.style.webkitUserSelect = "none";

        svg.addEventListener("pointerdown", onRectStart);
        svg.addEventListener("pointermove", onRectMove);
        svg.addEventListener("pointerup", onRectEnd);
        svg.addEventListener("pointercancel", onRectCancel);
      }

      // ⏳ HARD 1s DELAY (intentional, deterministic)
      //setTimeout(() => {
      //  readyRef.current = true;
      //  setReady(true);
        renderFromValue(valueRef.current);
      //}, 10);
    })();
  }, [scoreImage]);

  useEffect(() => {
    if (!readyRef.current) return; // ⏳ ADDED
    renderFromValue(value);
  }, [value, mode]);

  /* ───────── RECT MODE ───────── */

  // function onRectStart(e) {
  //   if (!readyRef.current) return;
  //   if (modeRef.current === "review") return;

  //   const svg = containerRef.current.querySelector("svg");
  //   if (!svg) return;

  //   isDraggingRef.current = true;
  //   dragStartRef.current = getSvgPoint(svg, e.clientX, e.clientY);

  //   annotationLayerRef.current.style.pointerEvents = "none";

  //   annotationLayerRef.current
  //     ?.querySelectorAll(".drag-rect")
  //     .forEach(n => n.remove());
  // }

  // function onRectMove(e) {
  //   if (!readyRef.current) return;
  //   if (!isDraggingRef.current) return;

  //   const svg = containerRef.current.querySelector("svg");
  //   if (!svg) return;

  //   const start = dragStartRef.current;
  //   const curr = getSvgPoint(svg, e.clientX, e.clientY);
  //   const rect = normalizeRect(start, curr);

  //   annotationLayerRef.current
  //     ?.querySelectorAll(".drag-rect")
  //     .forEach(n => n.remove());

  //   const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  //   r.setAttribute("x", rect.x);
  //   r.setAttribute("y", rect.y);
  //   r.setAttribute("width", rect.width);
  //   r.setAttribute("height", rect.height);
  //   r.setAttribute("fill", "rgba(30,144,255,0.2)");
  //   r.setAttribute("stroke", "dodgerblue");
  //   r.setAttribute("stroke-width", "2");
  //   r.classList.add("drag-rect");
  //   r.style.pointerEvents = "none";

  //   annotationLayerRef.current.appendChild(r);
  // }

  // // function onRectEnd(e) {
  // //   if (!readyRef.current) return;
  // //   if (!isDraggingRef.current) return;
  // //   isDraggingRef.current = false;

  // //   const svg = containerRef.current.querySelector("svg");
  // //   if (!svg) return;

  // //   const start = dragStartRef.current;
  // //   const end = getSvgPoint(svg, e.clientX, e.clientY);
  // //   const bbox = normalizeRect(start, end);

  // //   annotationLayerRef.current.style.pointerEvents = "auto";

  // //   annotationLayerRef.current
  // //     ?.querySelectorAll(".drag-rect")
  // //     .forEach(n => n.remove());

  // //   dragStartRef.current = null;
  // //   if (bbox.width < 5 || bbox.height < 5) return;

  // //   onChange({ type: "rect", bbox });
  // //   renderFromValue({ type: "rect", bbox });
  // // }
  // function onRectEnd(e) {
  //   if (!readyRef.current) return;
  //   if (!isDraggingRef.current) return;
  //   isDraggingRef.current = false;

  //   const svg = containerRef.current.querySelector("svg");
  //   if (!svg) return;

  //   const start = dragStartRef.current;
  //   const end = getSvgPoint(svg, e.clientX, e.clientY);
  //   const bbox = normalizeRect(start, end);

  //   annotationLayerRef.current.style.pointerEvents = "auto";

  //   annotationLayerRef.current
  //     ?.querySelectorAll(".drag-rect")
  //     .forEach(n => n.remove());

  //   dragStartRef.current = null;
  //   if (bbox.width < 5 || bbox.height < 5) return;

  //   // ✅ FIND NOTEHEADS IN RECT
  //   const notesInBox = noteheadsRef.current
  //     .filter(n => pointInRect(n, bbox))
  //     .map(n => n.id);

  //   const payload = {
  //     type: "rect",
  //     bbox,
  //     hits: notesInBox
  //   };

  //   onChange(payload);
  //   renderFromValue(payload);
  // }
  function onRectStart(e) {
  if (!readyRef.current) return;
  if (modeRef.current === "review") return;

  // Only accept the primary mouse button, but allow touch and Pencil.
  if (e.pointerType === "mouse" && e.button !== 0) return;

  const svg = containerRef.current?.querySelector("svg");
  if (!svg) return;

  e.preventDefault();

  /*
   * Keep receiving move/up events even when the pointer leaves the SVG.
   * This is especially important on iPad.
   */
  try {
    svg.setPointerCapture(e.pointerId);
  } catch {
    // Pointer capture may not be available in an older browser.
  }

  isDraggingRef.current = true;
  dragStartRef.current = getSvgPoint(svg, e.clientX, e.clientY);

  if (annotationLayerRef.current) {
    annotationLayerRef.current.style.pointerEvents = "none";

    annotationLayerRef.current
      .querySelectorAll(".drag-rect")
      .forEach(node => node.remove());
  }
}

function onRectMove(e) {
  if (!readyRef.current) return;
  if (!isDraggingRef.current) return;

  const svg = containerRef.current?.querySelector("svg");
  const start = dragStartRef.current;

  if (!svg || !start) return;

  e.preventDefault();

  const current = getSvgPoint(svg, e.clientX, e.clientY);
  const rect = normalizeRect(start, current);

  annotationLayerRef.current
    ?.querySelectorAll(".drag-rect")
    .forEach(node => node.remove());

  const selectionRect = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "rect"
  );

  selectionRect.setAttribute("x", String(rect.x));
  selectionRect.setAttribute("y", String(rect.y));
  selectionRect.setAttribute("width", String(rect.width));
  selectionRect.setAttribute("height", String(rect.height));
  selectionRect.setAttribute("fill", "rgba(30,144,255,0.2)");
  selectionRect.setAttribute("stroke", "dodgerblue");
  selectionRect.setAttribute("stroke-width", "2");

  selectionRect.classList.add("drag-rect");
  selectionRect.style.pointerEvents = "none";

  annotationLayerRef.current?.appendChild(selectionRect);
}

function onRectEnd(e) {
  if (!readyRef.current) return;
  if (!isDraggingRef.current) return;

  const svg = containerRef.current?.querySelector("svg");
  const start = dragStartRef.current;

  isDraggingRef.current = false;
  dragStartRef.current = null;

  if (!svg || !start) {
    restoreRectInteraction();
    return;
  }

  e.preventDefault();

  try {
    if (svg.hasPointerCapture(e.pointerId)) {
      svg.releasePointerCapture(e.pointerId);
    }
  } catch {
    // Ignore unsupported pointer-capture behavior.
  }

  const end = getSvgPoint(svg, e.clientX, e.clientY);
  const bbox = normalizeRect(start, end);

  restoreRectInteraction();

  /*
   * These values are now SVG units rather than screen pixels.
   */
  if (bbox.width < 5 || bbox.height < 5) return;

  const hitNotes = noteheadsRef.current
    .filter(note => pointInRect(note, bbox));

  const notesInBox = hitNotes.map(note => note.id);
  const selectedNotes = hitNotes.map(note => ({
    id: note.id,
    noteKey: note.noteKey,
    measureKey: note.measureKey,
    measureNumber: note.measureNumber,
    pitchKey: note.pitchKey
  }));

  if (selectionMode === "multiple") {
    const currentRects = Array.isArray(valueRef.current?.rects)
      ? valueRef.current.rects
      : [];

    if (maxSelections && currentRects.length >= maxSelections) {
      return;
    }

    const rects = [
      ...currentRects,
      { bbox, hits: notesInBox, selectedNotes }
    ];

    const allSelectedNotes = rects
      .flatMap(rect => rect.selectedNotes || [])
      .filter((note, index, all) =>
        all.findIndex(other => other.noteKey === note.noteKey) === index
      );

    const payload = {
      type: "rect",
      rects,
      hits: allSelectedNotes.map(note => note.id),
      selectedNotes: allSelectedNotes
    };

    onChange(payload);
    renderFromValue(payload);
    return;
  }

  const payload = {
    type: "rect",
    bbox,
    hits: notesInBox,

    // Keep enough semantic information for rule-based rect questions
    // (for example: "select repeated notes within the same measure").
    // Existing rect questions continue to grade against `hits`.
    selectedNotes
  };

  onChange(payload);
  renderFromValue(payload);
}

function onRectCancel(e) {
  const svg = containerRef.current?.querySelector("svg");

  isDraggingRef.current = false;
  dragStartRef.current = null;

  if (svg) {
    try {
      if (svg.hasPointerCapture(e.pointerId)) {
        svg.releasePointerCapture(e.pointerId);
      }
    } catch {
      // Ignore unsupported pointer-capture behavior.
    }
  }

  restoreRectInteraction();
}

function restoreRectInteraction() {
  if (annotationLayerRef.current) {
    /*
     * The annotation group itself should not intercept empty-space
     * gestures. Individual selection rectangles can still use
     * pointerEvents = "all".
     */
    annotationLayerRef.current.style.pointerEvents = "none";

    annotationLayerRef.current
      .querySelectorAll(".drag-rect")
      .forEach(node => node.remove());
  }
}

function classifySymbolElement(el, fallbackType) {
  const text = (el.textContent || "").trim().toLowerCase();

  if (text === "f" || text === "𝒇") return "forte";
  if (text === "p" || text === "𝒑") return "piano";
  if (text === "mf" || text === "𝒎𝒇") return "mezzo-forte";
  if (text === "mp" || text === "𝒎𝒑") return "mezzo-piano";

  return fallbackType;
}

  function extractSymbolsFromDOM() {
  const svg = containerRef.current?.querySelector("svg");
  if (!svg) return;

  const svgRect = svg.getBoundingClientRect();
  const symbols = [];

  function addSymbol(type, bbox, idPrefix = type) {
    if (
      !bbox ||
      !Number.isFinite(bbox.x) ||
      !Number.isFinite(bbox.y) ||
      bbox.width <= 0 ||
      bbox.height <= 0
    ) {
      return;
    }

    symbols.push({
      id: `${idPrefix}-${symbols.length}`,
      type,
      bbox
    });
  }

  function getElementBBox(element) {
    const elements = [
      element,
      ...Array.from(element.querySelectorAll("*"))
    ];

    const boxes = elements
      .map(el => el.getBoundingClientRect())
      .filter(
        box =>
          Number.isFinite(box.left) &&
          Number.isFinite(box.top) &&
          box.width > 0 &&
          box.height > 0
      );

    if (!boxes.length) return null;

    const left = Math.min(...boxes.map(box => box.left));
    const right = Math.max(...boxes.map(box => box.right));
    const top = Math.min(...boxes.map(box => box.top));
    const bottom = Math.max(...boxes.map(box => box.bottom));

    return {
      x: left - svgRect.left,
      y: top - svgRect.top,
      width: right - left,
      height: bottom - top
    };
  }

  const groups = [
    { sel: ".vf-timesignature", type: "time signature" },
    { sel: ".vf-keysignature", type: "key signature" },
    { sel: ".vf-clef", type: "clef" },
    { sel: ".vf-text", type: "text" },
    { sel: ".vf-symbol", type: "symbol" },
    { sel: ".vf-notehead", type: "note" },
    { sel: ".vf-curve", type: "curve" }
  ];

  groups.forEach(({ sel, type }) => {
    svg.querySelectorAll(sel).forEach(element => {
      const bbox = getElementBBox(element);
      if (!bbox) return;

      addSymbol(
        classifySymbolElement(element, type),
        bbox,
        type
      );
    });
  });

  /*
   * Barlines are not included in the symbol selectors above.
   * Locate narrow, staff-height SVG shapes and group nearby shapes
   * together. Two nearby vertical shapes represent a double barline.
   */
  const barlineCandidates = Array.from(
    svg.querySelectorAll("rect, path, line")
  )
    .filter(element => {
      if (element.closest("#annotation-layer")) return false;

      const box = element.getBoundingClientRect();

      if (!box.width || !box.height) return false;

      return (
        box.height >= 25 &&
        box.width <= 8
      );
    })
    .map(element => {
      const box = element.getBoundingClientRect();

      return {
        element,
        left: box.left,
        right: box.right,
        top: box.top,
        bottom: box.bottom,
        width: box.width,
        height: box.height,
        centerX: box.left + box.width / 2
      };
    })
    .sort((a, b) => {
      if (Math.abs(a.top - b.top) > 8) {
        return a.top - b.top;
      }

      return a.centerX - b.centerX;
    });

  const clusters = [];

  barlineCandidates.forEach(candidate => {
    const existing = clusters.find(cluster => {
      const sameVerticalPosition =
        Math.abs(cluster.top - candidate.top) <= 8 &&
        Math.abs(cluster.bottom - candidate.bottom) <= 8;

      const horizontallyClose =
        Math.abs(cluster.lastCenterX - candidate.centerX) <= 12;

      return sameVerticalPosition && horizontallyClose;
    });

    if (existing) {
      existing.items.push(candidate);
      existing.left = Math.min(existing.left, candidate.left);
      existing.right = Math.max(existing.right, candidate.right);
      existing.top = Math.min(existing.top, candidate.top);
      existing.bottom = Math.max(existing.bottom, candidate.bottom);
      existing.lastCenterX = candidate.centerX;
    } else {
      clusters.push({
        items: [candidate],
        left: candidate.left,
        right: candidate.right,
        top: candidate.top,
        bottom: candidate.bottom,
        lastCenterX: candidate.centerX
      });
    }
  });

  clusters.forEach((cluster, index) => {
    /*
     * Ignore isolated narrow shapes that are likely stems rather than
     * barlines. Barlines should span a substantial portion of a staff.
     */
    const height = cluster.bottom - cluster.top;

    if (height < 25) return;

    const isDouble = cluster.items.length >= 2;

    /*
     * 10B asks specifically for a double bar line, so only expose
     * clusters containing at least two adjacent vertical shapes.
     */
    if (!isDouble) return;

    const horizontalPadding = 10;
    const verticalPadding = 4;

    addSymbol(
      "double bar line",
      {
        x:
          cluster.left -
          svgRect.left -
          horizontalPadding,
        y:
          cluster.top -
          svgRect.top -
          verticalPadding,
        width:
          cluster.right -
          cluster.left +
          horizontalPadding * 2,
        height:
          cluster.bottom -
          cluster.top +
          verticalPadding * 2
      },
      `double-barline-${index}`
    );
  });

  hitRegionsRef.current.symbols = symbols;
}

  function drawMeasureHitRects() {
    if (!annotationLayerRef.current) return;

    hitRegionsRef.current.measures.forEach(m => {
      const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");

      r.setAttribute("x", m.bbox.x);
      r.setAttribute("y", m.bbox.y);
      r.setAttribute("width", m.bbox.width);
      r.setAttribute("height", m.bbox.height);
      r.setAttribute("fill", "rgba(30,144,255,0)");

      r.classList.add("measure-hit"); // ✅ NEW
      r.style.pointerEvents = "all";
      r.style.cursor = "pointer";

      r.addEventListener("click", e => {
        e.stopPropagation();
        if (modeRef.current === "review") return;

        const current = localMeasuresRef.current;
        const isSelected = current.includes(m.id);

        let next;
        if (selectionMode === "single") {
          next = isSelected ? [] : [m.id];
        } else {
          next = isSelected
            ? current.filter(id => id !== m.id)
            : [...current, m.id];
        }

        localMeasuresRef.current = next;
        onChange({ measures: next });
        renderFromValue({ measures: next });
      });

      annotationLayerRef.current.appendChild(r);
    });
  }


  function drawSymbolHitRects() {
    if (!annotationLayerRef.current) return;
    annotationLayerRef.current
    .querySelectorAll(".symbol-hit")
    .forEach(n => n.remove());


    hitRegionsRef.current.symbols.forEach(sym => {
      const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");

      r.setAttribute("x", sym.bbox.x);
      r.setAttribute("y", sym.bbox.y);
      r.setAttribute("width", sym.bbox.width);
      r.setAttribute("height", sym.bbox.height);
      r.setAttribute("fill", "rgba(30,144,255,0)");
      r.setAttribute("stroke", "dodgerblue");
      r.setAttribute("stroke-width", "0");
      r.style.cursor = "pointer";
      r.style.pointerEvents = "all";
      r.classList.add("symbol-hit");
      r.style.pointerEvents = "all";

      r.addEventListener("click", e => {
        e.stopPropagation();
        if (modeRef.current === "review") return;

        onChange({
          type: "symbol",
          symbolType: sym.type,
          bbox: sym.bbox,
          id: sym.id
        });

        renderFromValue({
          type: "symbol",
          symbolType: sym.type,
          bbox: sym.bbox,
          id: sym.id
        });
      });

      annotationLayerRef.current.appendChild(r);
    });
  }

  /* ───────── MEASURES ───────── */

  function extractMeasuresFromDOM() {
    const svg = containerRef.current.querySelector("svg");
    if (!svg) return;

    const svgRect = svg.getBoundingClientRect();
    const measures = [];

    svg.querySelectorAll("g.vf-measure").forEach((g, i) => {
      const r = g.getBoundingClientRect();
      measures.push({
        id: i,
        bbox: {
          x: r.left - svgRect.left,
          y: r.top - svgRect.top,
          width: r.width,
          height: r.height
        }
      });
    });

    hitRegionsRef.current.measures = measures;
  }

  function handleMeasureClick(x, y) {
    const m = hitRegionsRef.current.measures.find(r => hit(r.bbox, x, y));
    if (!m) return;

    const next =
      selectionMode === "single"
        ? [m.id]
        : localMeasuresRef.current.includes(m.id)
        ? localMeasuresRef.current.filter(i => i !== m.id)
        : [...localMeasuresRef.current, m.id];

    localMeasuresRef.current = next;
    onChange({ measures: next });
    renderFromValue({ measures: next });
  }

  /* ───────── RECT MODE (unchanged) ───────── */

  function attachClickHandler() {
    const svg = containerRef.current?.querySelector("svg");
    if (!svg) return;

    if (interactionMode === "rect") {
      svg.addEventListener("mousedown", onRectStart);
      svg.addEventListener("mousemove", onRectMove);
      svg.addEventListener("mouseup", onRectEnd);
      return;
    }

    if (interactionMode === "measure") {
      svg.addEventListener("click", e => {
        if (modeRef.current === "review") return;
        const r = svg.getBoundingClientRect();
        handleMeasureClick(e.clientX - r.left, e.clientY - r.top);
      });
    }
  }

  /* ───────── NOTE EXTRACTION (unchanged) ───────── */

  function extractNoteheadsFromOSMD() {
    const osmd = osmdRef.current;
    if (!osmd) return;

    const out = [];
    let logicalMeasureNumber = 0;

    osmd.GraphicSheet.MusicPages.forEach((page, pageIndex) => {
      page.musicSystems.forEach((system, systemIndex) => {
        system.graphicalMeasures.forEach((mg, m) => {
          // graphicalMeasures groups all staves belonging to one logical
          // measure. Keep a global 1-based number so semantic rect rules can
          // target prompts such as "measure two" even across system breaks.
          logicalMeasureNumber += 1;

          mg.forEach((measure, s) => {
            if (!measure) return;
            measure.staffEntries.forEach((se, entryIndex) => {
              se.graphicalVoiceEntries.forEach((gve, v) => {
                gve.notes.forEach((note, n) => {
                  const el = note.vfnote?.[0]?.attrs?.el;
                  if (!el) return;

                  const bb = el.getBBox();
                  const ctm = el.getCTM();
                  const sourcePitch = note.sourceNote?.Pitch;

                  let pitchKey = null;
                  if (sourcePitch) {
                    if (typeof sourcePitch.ToStringShort === "function") {
                      pitchKey = sourcePitch.ToStringShort();
                    } else {
                      pitchKey = [
                        sourcePitch.FundamentalNote,
                        sourcePitch.Octave,
                        sourcePitch.Accidental
                      ].join(":");
                    }
                  }

                  out.push({
                    // Preserve the legacy ID because existing triad questions
                    // have hard-coded `correct.hits` values using this format.
                    id: `m${m}-s${s}-v${v}-n${n}`,
                    noteKey: `p${pageIndex}-y${systemIndex}-m${m}-s${s}-e${entryIndex}-v${v}-n${n}`,
                    measureKey: `${pageIndex}-${systemIndex}-${m}`,
                    measureNumber: logicalMeasureNumber,
                    pitchKey,
                    cx: bb.x * ctm.a + bb.y * ctm.c + ctm.e + (bb.width * ctm.a) / 2,
                    cy: bb.x * ctm.b + bb.y * ctm.d + ctm.f + (bb.height * ctm.d) / 2
                  });
                });
              });
            });
          });
        });
      });
    });

    noteheadsRef.current = out;
  }

  /* ───────── SVG LAYER ───────── */

  function ensureAnnotationLayer() {
    const svg = containerRef.current?.querySelector("svg");
    if (!svg) return;

    // IMPORTANT: attach directly to <svg>, not OSMD's root <g>
    let layer = svg.querySelector("#annotation-layer");

    if (!layer) {
      layer = document.createElementNS("http://www.w3.org/2000/svg", "g");
      layer.setAttribute("id", "annotation-layer");
      layer.style.pointerEvents = "none"; // default
      svg.appendChild(layer);
    }

    annotationLayerRef.current = layer;
  }

  /* ───────── RENDER ───────── */

  function renderFromValue(v) {
    ensureAnnotationLayer();
    if (!annotationLayerRef.current) return;

    annotationLayerRef.current
      .querySelectorAll(".selection-rect")
      .forEach(n => n.remove());

    const isReview = modeRef.current === "review";

    /* ───── SYMBOL SELECTION ───── */
    if (interactionMode === "symbol" && v?.bbox) {
      const correct =
        feedback?.parts?.symbol?.correct === true;

      drawSelectionRect(
        v.bbox,
        modeRef.current === "review",
        correct,
        () => {
          onChange(null);
          renderFromValue(null);
        }
      );
    }

    /* ───── MEASURE SELECTION ───── */
    if (interactionMode === "measure" && Array.isArray(v?.measures)) {
      // const correct =
      //   feedback?.parts?.measures?.correct === true;
      const correct =
        feedback?.parts &&
        Object.values(feedback.parts).length > 0 &&
        Object.values(feedback.parts).every(p => p.correct === true);

      v.measures.forEach(id => {
        const m = hitRegionsRef.current.measures.find(mm => mm.id === id);
        if (!m) return;

        drawSelectionRect(
          m.bbox,
          modeRef.current === "review",
          correct,
          () => {
            const next =
              selectionMode === "single"
                ? []
                : v.measures.filter(x => x !== id);

            localMeasuresRef.current = next;
            onChange({ measures: next });
            renderFromValue({ measures: next });
          }
        );
      });
    }


    /* ───── RECT SELECTION ───── */
    if (interactionMode === "rect") {
      const correct = feedback?.parts?.rect?.correct === true;

      if (selectionMode === "multiple" && Array.isArray(v?.rects)) {
        v.rects.forEach((rect, index) => {
          if (!rect?.bbox) return;

          drawSelectionRect(
            rect.bbox,
            modeRef.current === "review",
            correct,
            () => {
              const rects = v.rects.filter((_, i) => i !== index);
              const selectedNotes = rects
                .flatMap(item => item.selectedNotes || [])
                .filter((note, noteIndex, all) =>
                  all.findIndex(other => other.noteKey === note.noteKey) === noteIndex
                );

              const next = {
                type: "rect",
                rects,
                hits: selectedNotes.map(note => note.id),
                selectedNotes
              };

              onChange(next);
              renderFromValue(next);
            }
          );
        });
      } else if (v?.bbox) {
        drawSelectionRect(
          v.bbox,
          modeRef.current === "review",
          correct,
          () => {
            onChange(null);
            renderFromValue(null);
          }
        );
      }
    }


  }


  function drawSelectionRect(bbox, isReview, correct, onClear) {
    const pad = 4;
    const r = document.createElementNS("http://www.w3.org/2000/svg", "rect");

    r.setAttribute("x", bbox.x - pad);
    r.setAttribute("y", bbox.y - pad);
    r.setAttribute("width", bbox.width + pad * 2);
    r.setAttribute("height", bbox.height + pad * 2);

    if (isReview) {
      r.setAttribute(
        "fill",
        correct
          ? "rgba(46,125,50,0.25)"
          : "rgba(198,40,40,0.25)"
      );
      r.setAttribute(
        "stroke",
        correct ? "#2e7d32" : "#c62828"
      );
    } else {
      r.setAttribute("fill", "rgba(30,144,255,0.25)");
      r.setAttribute("stroke", "dodgerblue");
    }

    r.setAttribute("stroke-width", "3");
    r.classList.add("selection-rect");
    r.style.pointerEvents = "all";
    r.style.cursor = isReview ? "default" : "pointer";

    /*
     * Existing selection rectangles sit inside the same SVG that listens
     * for pointerdown to begin a new drag selection. Without stopping the
     * pointerdown here, the SVG captures the pointer and the rectangle's
     * later click event is lost, so "click to remove" never fires.
     */
    r.addEventListener("pointerdown", e => {
      e.stopPropagation();
    });

    r.addEventListener("click", e => {
      e.stopPropagation();
      if (isReview) return;
      onClear();
    });

    annotationLayerRef.current.appendChild(r);
  }

  function updateSubQuestionAnswer(questionId, answerValue) {
    onChange({
      ...valueRef.current,
      questionAnswers: {
        ...(valueRef.current.questionAnswers || {}),
        [questionId]: answerValue
      }
    });
  }

  function SubQuestions() {
  if (!Array.isArray(config.questions)) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12
      }}
    >
      {config.questions.map((q, index) => {
        const selected =
          value?.questionAnswers?.[q.id] || "";

        const label =
          q.label ?? String.fromCharCode(65 + index);

        const partFeedback =
          feedback?.parts?.questionAnswers?.[q.id] ||
          feedback?.parts?.[q.id];

        const border =
          mode === "review"
            ? partFeedback?.correct
              ? "2px solid #2e7d32"
              : "2px solid #c62828"
            : "1px solid #aaa";

        return (
          <div
            key={q.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap"
            }}
          >
            <div
              style={{
                fontWeight: 700,
                minWidth: 22
              }}
            >
              {label}.
            </div>

            <div style={{ marginRight: 6 }}>
              {q.text}
            </div>

            {q.type === "text" ? (
                <div style={{ position: "relative" }}>
                  <input
                    value={selected}
                    disabled={mode !== "edit"}
                    onFocus={() => setActiveTextField(`question:${q.id}`)}
                    onBlur={() => setActiveTextField(null)}
                    onChange={(e) =>
                      updateSubQuestionAnswer(q.id, e.target.value.toUpperCase())
                    }
                    style={{
                      width: q.inputWidth || 120,
                      height: 34,
                      fontSize: 16,
                      padding: "4px 8px",
                      border,
                      borderRadius: 6
                    }}
                  />

                  {activeTextField === `question:${q.id}` &&
                    mode === "edit" && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          marginTop: 4,
                          zIndex: 10
                        }}
                      >
                        <AccidentalButtons
                          onSelect={(acc) =>
                            updateSubQuestionAnswer(
                              q.id,
                              insertAccidental(selected, acc)
                            )
                          }
                        />
                      </div>
                    )}
                </div>
              ) : (
              <div style={{ display: "flex", gap: 8 }}>
                {(q.choices || []).map(choice => {
                  const choiceValue =
                    typeof choice === "string"
                      ? choice
                      : choice.value;

                  const choiceLabel =
                    typeof choice === "string"
                      ? choice
                      : choice.label;

                  const isSelected =
                    selected === choiceValue;

                  const buttonBorder =
                    mode === "review" && isSelected
                      ? partFeedback?.correct
                        ? "2px solid #2e7d32"
                        : "2px solid #c62828"
                      : isSelected
                      ? "2px solid #1976d2"
                      : "1px solid #aaa";

                  return (
                    <button
                      key={choiceValue}
                      disabled={mode !== "edit"}
                      onClick={() =>
                        updateSubQuestionAnswer(q.id, choiceValue)
                      }
                      style={{
                        padding: "6px 12px",
                        fontSize: 16,
                        borderRadius: 6,
                        border: buttonBorder,
                        background: isSelected ? "#e3f2fd" : "#fff",
                        cursor: mode === "edit" ? "pointer" : "default"
                      }}
                    >
                      {choiceLabel}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

  return (
    <QuestionLayout hideFB={hideFB} number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback} hideNumber={config?.embedded === true} hidePoints={config?.embedded === true} promptSize={config?.embedded ? "compact" : "normal"}>
      <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 12
    }}
  >
    {/* ANSWERS ABOVE SCORE */}
    {(config.textInput || config.secondTextInput || config.binaryChoice) && (
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        {config.textInput && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6
            }}
          >
            {/* INPUT + ACCIDENTALS ANCHOR */}
            <div style={{ position: "relative" }}>
              <input
                value={value?.[config.textKey] || ""}
                disabled={mode !== "edit"}
                onFocus={() => setActiveTextField(config.textKey)}
                onBlur={() => setActiveTextField(null)}
                onChange={(e) =>
                  onChange({
                    ...valueRef.current,
                    [config.textKey]: e.target.value.toUpperCase()
                  })
                }
                style={{
                  width: config.inputWidth || 42,
                  height: 42,
                  textAlign: "center",
                  fontSize: 18,
                  border:
                    mode === "review"
                      ? (feedback?.parts?.[config.textKey]?.correct ??
                          feedback?.parts?.text?.correct)
                        ? "2px solid #2e7d32"
                        : "2px solid #c62828"
                      : "1px solid #aaa",
                  borderRadius: 4
                }}
              />

              {activeTextField === config.textKey &&
                mode === "edit" && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      marginTop: 4,
                      zIndex: 10
                    }}
                  >
                    <AccidentalButtons
                      onSelect={(acc) =>
                        onChange({
                          ...valueRef.current,
                          [config.textKey]: insertAccidental(
                            valueRef.current?.[config.textKey] || "",
                            acc
                          )
                        })
                      }
                    />
                  </div>
                )}
            </div>

            {config.suffix && (
              <span
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  whiteSpace: "nowrap"
                }}
              >
                {config.suffix}
              </span>
            )}
          </div>
        )}

        {config.secondTextInput && (
          <select
            value={value?.[config.secondTextKey] || ""}
            disabled={mode !== "edit"}
            onChange={(e) =>
              onChange({
                ...valueRef.current,
                [config.secondTextKey]: e.target.value
              })
            }
            style={{
              height: 42,
              fontSize: 18,
              padding: "0 10px",
              border:
                mode === "review"
                  ? feedback?.parts?.[config.secondTextKey]?.correct
                    ? "2px solid #2e7d32"
                    : "2px solid #c62828"
                  : "1px solid #aaa",
              borderRadius: 4
            }}
          >
            <option value="">—</option>

            {(config.secondTextChoices || []).map(choice => (
              <option
                key={choice}
                value={choice}
              >
                {choice}
              </option>
            ))}
          </select>
        )}

        {config.binaryChoice && (
          <div style={{ display: "flex", gap: 12 }}>
            {config.binaryLabels?.map((label, i) => {
              const val = i === 0;
              const checked = value?.binaryAnswer === val;

              return (
                <button
                  key={label}
                  disabled={mode === "review"}
                  onClick={() =>
                    onChange({
                      ...valueRef.current,
                      binaryAnswer: val
                    })
                  }
                  style={{
                    padding: "6px 12px",
                    borderRadius: 6,
                    border: "2px solid",
                    borderColor: checked ? "#1976d2" : "#ccc",
                    background: checked ? "#e3f2fd" : "#fff"
                  }}
                >
                  {label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    )}

    {!config.questionsBelow && SubQuestions()}

    {/* SCORE LAST */}
    {scoreImage ? (
      <div
        style={{
          width: config.scoreImageWidth ?? 1200,
          maxWidth: "100%",
          overflowX: "visible"
        }}
      >
        <ExamImage
          src={scoreImage}
          alt={config.scoreImageAlt ?? "Musical score"}
          style={{
            display: "block",
            width: config.scoreImageDisplayWidth ?? "100%",
            maxWidth: "none",
            height: "auto"
          }}
        />
      </div>
    ) : (
      <div
        ref={containerRef}
        style={{
          width: 1200,
          maxWidth: "100%",
          overflowX: "visible"
        }}
      />
    )}

    {config.questionsBelow && SubQuestions()}
  </div>

    </QuestionLayout>
  );
}

function AccidentalButtons({ onSelect }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {[
        { label: "♭", value: "♭" },
        { label: "♯", value: "♯" },
      ].map(({ label, value }) => (
        <button
          key={value}
          tabIndex={-1}
          style={{
            fontSize: 16,
            padding: "2px 6px",
            cursor: "pointer"
          }}
          onMouseDown={(e) => {
            e.preventDefault(); // prevent blur
            onSelect(value);
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

/* ───────── HELPERS ───────── */
function pointInRect(p, r) {
  return (
    p.cx >= r.x &&
    p.cx <= r.x + r.width &&
    p.cy >= r.y &&
    p.cy <= r.y + r.height
  );
}

function hit(b, x, y) {
  return x >= b.x && x <= b.x + b.width && y >= b.y && y <= b.y + b.height;
}

function getSvgPoint(svg, clientX, clientY) {
  const point = svg.createSVGPoint();

  point.x = clientX;
  point.y = clientY;

  const screenCTM = svg.getScreenCTM();

  if (!screenCTM) {
    const rect = svg.getBoundingClientRect();

    return {
      x: clientX - rect.left,
      y: clientY - rect.top
    };
  }

  const transformed = point.matrixTransform(screenCTM.inverse());

  return {
    x: transformed.x,
    y: transformed.y
  };
}

function normalizeRect(a, b) {
  const x = Math.min(a.x, b.x);
  const y = Math.min(a.y, b.y);
  return {
    x,
    y,
    width: Math.abs(a.x - b.x),
    height: Math.abs(a.y - b.y)
  };
}